// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationText_wrapper__ag6Bz"};